import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const ViewVideoDialog = ({ open, onClose, item }) => {
  const { t } = useTranslation();
  const url = item?.videoUrl;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{item?.trans || t("common.video")}</DialogTitle>
      <DialogContent>
        {url ? (
          <Box>
            <Box
              component="iframe"
              src={url}
              title={item?.trans}
              sx={{
                width: "100%",
                height: 360,
                border: 0,
                borderRadius: 1,
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {item?.trans}
            </Typography>
          </Box>
        ) : (
          <Typography color="text.secondary">
            {t("videotutorials.noVideoUrl")}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close")}</Button>
        {url && (
          <Button
            variant="contained"
            startIcon={<OpenInNewIcon />}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("videotutorials.openInNewTab")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ViewVideoDialog;
